import { Avatar, Typography, IconButton, SvgIcon } from '@mui/material';
import { FunctionComponent } from 'react';

import Icons from '@Constants/Icons.constants';

import { StyledStack } from './Header.styles';
import HeaderProps from './Header.types';

const Header: FunctionComponent<HeaderProps> = (
  props: HeaderProps
): JSX.Element => {
  const { username, onLogout, avatarUrl, avatarText, onProfileClick } = props;

  return (
    <StyledStack direction="row">
      <Typography variant="main">{username}</Typography>
      <IconButton className="avatarButton" onClick={onProfileClick}>
        <Avatar src={avatarUrl}>
          {avatarText || username.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>
      <IconButton className="logoutIcon" onClick={onLogout}>
        <SvgIcon fontSize="large">{Icons.logout}</SvgIcon>
      </IconButton>
    </StyledStack>
  );
};

export default Header;
